import { Controller } from "@hotwired/stimulus"

// Shows/hides a target section based on the value of a radio group or
// select. Usage:
//   data-controller="conditional-fields"
//   data-action="change->conditional-fields#toggle"
// on each radio/select, and on the section to reveal:
//   data-conditional-fields-target="section"
//   data-conditional-fields-show-when-value="business"
// The section is shown only when the currently-checked/selected value
// matches its own data-conditional-fields-show-when-value.
export default class extends Controller {
  static targets = ["section"]

  connect() {
    this.toggle()
  }

  toggle() {
    const checked = this.element.querySelector("input[type=radio]:checked, select")
    const currentValue = checked ? checked.value : null

    this.sectionTargets.forEach((section) => {
      const showWhen = section.dataset.conditionalFieldsShowWhenValue
      section.classList.toggle("d-none", showWhen !== currentValue)
    })
  }
}
